$(document).ready(function () {
  // показывает/скрывает элементы в расписании/групповом этапе
  $("#scheduleWatchAll").click(function (evt) {
    evt.preventDefault();
    $(".cm-schedule").toggleClass("cm-schedule--visible");

    if ($(".cm-schedule").hasClass("cm-schedule--visible")) {
      $("#scheduleWatchAll").text("Скрыть");
    } else {
      $("#scheduleWatchAll").text("Смотреть все");
    }
  });

  // загружает расписание/групповой этап
  function loadShedule(sheduleId) {
    // сбрасываем кнопку "смотреть все"
    $(".cm-schedule").removeClass("cm-schedule--visible");
    $("#scheduleWatchAll").text("Смотреть все");

    // делаем активной кнопку навигации
    $(".cm-schedule__link").removeClass("cm-schedule__link--active");
    $('.cm-schedule__link[data-schedule="' + sheduleId + '"]').addClass(
      "cm-schedule__link--active"
    );

    switch (sheduleId) {
      // групповой этап
      case "#schedule-2":
        // если групповой этап не загружен - загружаем
        if (!$("#schedule-2").length) {
          $(".cm-schedule").append(
            '<div class="cm-schedule__wrapper" id="schedule-2">Загрузка...</div>'
          );
          $.ajax({
            method: "POST",
            url: "ajax/loadcmgroup",
          }).done(function (resp) {
            $("#schedule-2").html(resp);
          });
        } else {
          // показываем из кеша
          $("#schedule-2").css({ display: "block" });
        }
        $("h2#schedule").text("Групповой этап");
        $("#schedule-1").css({ display: "none" });
        break;
      // расписание
      default:
        $("h2#schedule").text(
          "Расписание и коэффициенты матчей на каждый день"
        );
        $("#schedule-1").css({ display: "block" });
        $("#schedule-2").css({ display: "none" });
    }
  }

  // кнопки навигации расписания
  $(".cm-schedule__link").click(function (evt) {
    evt.preventDefault();
    const sheduleId = $(this).data("schedule");
    loadShedule(sheduleId);
  });

  // навигация расписания в содержании страницы
  $(".custom-contain__link--schedule").click(function () {
    const sheduleId = $(this).data("schedule");
    loadShedule(sheduleId);
  });
});
